import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';

interface DetailContainerProps {
  children: React.ReactNode;
  style?: ViewStyle;
  contentStyle?: ViewStyle;
}

const DetailContainer: React.FC<DetailContainerProps> = ({
  children,
  style,
  contentStyle,
}) => {
  const { isMobile } = useResponsiveLayout();

  // For detail screens: 60% width on all devices, centered
  const containerWidth = isMobile ? '75%' : '50%';

  return (
    <View style={[styles.outerContainer, style]}>
      <View
        style={[
          styles.innerContainer,
          { width: containerWidth, alignSelf: 'center' },
          contentStyle,
        ]}
      >
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  innerContainer: {
    flex: 1,
  },
});

export default DetailContainer;
